'use client';
import { isIterableSet } from './is.utils.js';

function iterToSet(r) {
    return isIterableSet(r) ? r : new Set(r);
}
function mergeIterables(...e) {
    let r = [];
    return e.forEach((e)=>{
        e && r.push(...Array.from(e));
    }), new Set(r);
}

export { iterToSet, mergeIterables };
